export default {
  highlightObject: null,
  clientSearch: false,
  lastClickedObjectNumber: null,
};
